import { HeaderComponent } from "../../../components/Header";
import { EmptyState, ErrorState } from "../../../components/States";
import { ReportForm, ReportPreview, ReportSkeleton } from "./components";
import {
  EMPTY_REPORT_DESCRIPTION,
  EMPTY_REPORT_TITLE,
  REPORTS_SUBTITLE,
  REPORTS_TITLE,
} from "./constants";
import { useReportsData } from "./hooks";
import { Wrapper } from "./styles";
import { ReportsPageProps } from "./types";

export const ReportsPage = ({ showPageHeader = true }: ReportsPageProps) => {
  const {
    report,
    isGenerating,
    isDownloading,
    errorMessage,
    generateReport,
    retry,
    downloadPdf,
  } = useReportsData();

  let resultView = null;

  if (isGenerating) {
    resultView = <ReportSkeleton />;
  } else if (errorMessage) {
    resultView = <ErrorState message={errorMessage} onRetry={retry} />;
  } else if (report?.isEmpty) {
    // Deliberately offers no download: a PDF of an empty report is a blank document.
    resultView = (
      <EmptyState
        title={EMPTY_REPORT_TITLE}
        description={EMPTY_REPORT_DESCRIPTION}
      />
    );
  } else if (report) {
    resultView = (
      <ReportPreview
        report={report}
        isDownloading={isDownloading}
        onDownload={downloadPdf}
      />
    );
  }

  return (
    <Wrapper>
      {showPageHeader ? (
        <HeaderComponent title={REPORTS_TITLE} subtitle={REPORTS_SUBTITLE} />
      ) : null}
      <ReportForm isGenerating={isGenerating} onGenerate={generateReport} />
      {resultView}
    </Wrapper>
  );
};
